import { RatingsProgramsDTO } from "../dto/RatingsProgramsDTO";
import { RatingProgramMap } from "../models/RatingProgramMap";

export const ratingsProgramsMapper = (dto: RatingsProgramsDTO) => {
  return new RatingProgramMap(dto.ratingId, dto.programId);
};
